import { config } from './chunk-QOFPRZSL.js';
import './chunk-7QVYU63E.js';

// src/config/env-prd.ts
config.initialize("prd");
config.set((conf) => {
  conf.urls = {
    ...conf.urls,
    apiGateway: "https://api.jwplayer.com",
    contentServer: "https://cdn.jwplayer.com"
  };
});
//# sourceMappingURL=env-prd-U77MU6IO.js.map
//# sourceMappingURL=env-prd-U77MU6IO.js.map